import { PersonalMenuSetHdrContainer } from "../../../../../models/aggregates/personal-menu/personal-menu-set-hdr-container.model";
import { BaseApiTemplateService, Core2Config } from "../shared";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: "root" })
export class PersonalMenuSetHdrService extends BaseApiTemplateService<PersonalMenuSetHdrContainer> {
  url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "app-psnl-menu-set-hdr/" + Core2Config.LOGIN_EP_SUFFIX;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "app-psnl-menu-set-hdr/" + Core2Config.LOGIN_EP_SUFFIX;
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "app-psnl-menu-set-hdr/" + Core2Config.LOGIN_EP_SUFFIX;
    this.httpClient = http;
  }
}